import script from "./BackDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BackDialog.vue?vue&type=style&index=0&id=345e79de&lang=scss"

const __exports__ = script;

export default __exports__